/***********************************
    // Menu Style Color
    // black, white, teal, purple
***********************************/
const menuStyle = "purple";


/***********************************
    // Menu Type
    // dark, light, colored
***********************************/
const menuType = "colored";



/***********************************
    // Top Bar Style Color
    // black, white, teal, purple
***********************************/
const topbarStyle = "white";


/***********************************
    // Top bar Type
    // dark, light, colored
***********************************/
const topbarType = "light";

/***********************************
    // Navigation Width
    // default, mini
***********************************/
const navWidth = "default";

/***********************************
    // Chat Type
    // overlap, squeeze
***********************************/
const chatType = "overlap";

/***********************************
    // Chat Width
    // closed, open
***********************************/
const chatWidth = "closed";

 // mini


export {
    menuStyle,
    topbarStyle,
    menuType,
    topbarType,
    navWidth,
    chatWidth,
    chatType,
};
